import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../network/API";
import { axiosClient, phpClient } from "../../../network";
import { getNotificationDetailRequest, IRejectWithValue, NotificationDetailV2, PhpResponse } from "../../../types";
import { getUnreadNotifCount } from "../common";

export const getCategories = createAsyncThunk("/categories", async (undefined, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
        const response = await API.get("/notification/category");
        return response.data;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const getInbox = createAsyncThunk(
    "/inbox",
    async (data: { dateRange?: string; category?: string[] }, thunkAPI) => {
        const { rejectWithValue } = thunkAPI;
        try {
            const response = await axiosClient.post({ url: "/notification/inbox", data });
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getInboxDetails = createAsyncThunk(
    "/inbox/details",
    async (data: { notificationId: number }, thunkAPI) => {
        const { rejectWithValue } = thunkAPI;

        try {
            const response = await API.get(`/notification/inbox/details`, {
                params: data,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getNotifications = createAsyncThunk<NotificationDetailV2[], void, IRejectWithValue>(
    "notification/getNotifications",
    async (_, { rejectWithValue }) => {
        try {
            const response = await phpClient.post<PhpResponse<NotificationDetailV2[]>>({
                url: "/notification",
            });

            return response.data ?? [];
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const getNotificationDetail = createAsyncThunk<
    NotificationDetailV2 | undefined,
    getNotificationDetailRequest,
    IRejectWithValue
>("notification/getNotificationDetails", async (data, { rejectWithValue, dispatch }) => {
    const { notificationId, employeeId } = data;
    try {
        const response = await phpClient.post<PhpResponse<NotificationDetailV2>>({
            url: `/notification/details/${notificationId}`,
            data: {
                notification_id: notificationId,
                read_status: 1
            },
        });

        try {
            await dispatch(getUnreadNotifCount({
                employee_id: employeeId.toString()
            }));
        } catch (e) {
            console.warn("Failed to update unread count", e);
        }

        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});
